<template>
  <v-app lang="ja">
    <v-app-bar
      app
      color="white"
      dark
    >
      <div >
        <v-img
          alt="Logo"
          class="mr-2"
          contain
          src="./assets/e-jan.png"
          transition="scale-transition"
          width="150px"
          max-width="150px"
        />
      </div>
  </v-app-bar>

    <v-content>
      <EJanPortal/>
    </v-content>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import EJanPortal from './components/EJanPortal.vue';

export default Vue.extend({
  name: 'App',
  components: {
    EJanPortal,
  },
  created() {
    const html = document.documentElement // returns the html tag
    html.setAttribute('lang', 'ja')
  },
  data: () => ({
    //
  }),
});
</script>
